var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-header',{attrs:{"title":"Таможенные лимиты"}},[_c('q-btn',{attrs:{"to":{ name: _vm.routes.limitCreate },"unelevated":"","color":"primary","no-caps":"","no-wrap":"","label":"Новый лимит"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }